import { CONTACT_EMAIL, LOCATION, ORGANIZATION_NAME } from '../constants';

function ContactSection() {
  return (
    <section id="contact" className="bg-hub-cream px-5 py-20 md:py-28">
      <div className="mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-hub-sun text-hub-forest shadow-soft">
        <div className="grid gap-8 p-8 md:grid-cols-12 md:p-12">
          <div className="md:col-span-7">
            <p className="text-xs font-black uppercase tracking-[0.28em] text-hub-coral">Contact</p>
            <h2 className="mt-5 font-display text-4xl font-bold leading-tight md:text-6xl">
              Let’s build more meaningful days together.
            </h2>
          </div>
          <div className="md:col-span-5">
            <div className="rounded-[2rem] bg-hub-paper p-6 text-hub-forest">
              <p className="text-sm font-black uppercase tracking-[0.22em] text-hub-muted">Location</p>
              <p className="mt-2 text-2xl font-bold">{LOCATION}</p>
              <p className="mt-6 text-sm font-black uppercase tracking-[0.22em] text-hub-muted">General inquiries</p>
              <a href={`mailto:${CONTACT_EMAIL}`} className="mt-2 block break-words text-2xl font-bold text-hub-coral hover:text-hub-forest">
                {CONTACT_EMAIL}
              </a>
            </div>
          </div>
        </div>
      </div>
      <p className="sr-only">Contact {ORGANIZATION_NAME}</p>
    </section>
  );
}

export default ContactSection;
